<template>
  <li
    class="nav-header nav-item"
    v-bind="$attrs"
  >
    <!-- @slot Use this slot for header content -->
    <slot>
      {{ text }}
    </slot>
  </li>
</template>

<script>
export default {
  name: 'DpNavHeader',

  props: {
    text: {
      required: false,
      type: String,
      default: '',
    },
  },
};
</script>
